import { Injectable } from '@angular/core';
import {DataService} from "./data.service";
import {Store} from "@ngrx/store";
import {AppState} from "../store";
import {setActiveClassIdStudent} from "../store/actions/student.actions";
import {SchoolClassData} from "../interfaces/school-class-data";
import {BehaviorSubject, Observable} from "rxjs";
import {SchoolClassLogin} from "../interfaces/backend/school-class-login";

@Injectable({
  providedIn: 'root'
})
export class StudentAuthService {

  lastResponseData: SchoolClassLogin | null = null;
  private classData?: SchoolClassData;
  private _isLoggedIn = new BehaviorSubject<boolean>(false);
  private _clientId = "";

  private readonly LOCAL_STORAGE_KEY_LAST_CLASS_CODE_INPUT= "class_code_input";

  private notLoggedInError = new Error("School Class Data not set or not logged in");

  constructor(
    private dataService: DataService,
    private store: Store<AppState>
  ) { }

  getClassData(): SchoolClassData {
    if(this.classData) {
      return this.classData;
    }
    throw this.notLoggedInError;
  }

  async logInUsingLocalStorage(): Promise<boolean> {
    const schoolClassCode = this.getLastSuccessClassCode() ?? "";
    if (schoolClassCode.length === 0) {
      return false;
    }

    return this.logIn(schoolClassCode);
  }
  async logIn(schoolClassCode: string): Promise<boolean> {
    const isSuccess = await new Promise<boolean>((resolve, reject) => {
      this.dataService.loginSchoolClass(schoolClassCode).subscribe(response => {
        this.lastResponseData = response || null;

        if(response && response.status.type === "OK" && response.clientId && response.clientId.length > 0 && response.schoolClass) {
          localStorage.setItem('schoolClassCode', schoolClassCode);
          localStorage.setItem('clientId', response.clientId);
          this.store.dispatch(setActiveClassIdStudent({classId: response.schoolClass.id.toString()})); // TODO: better remove
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });

    const response = this.lastResponseData;
    if(isSuccess && response?.schoolClass) {
      // console.log(response);
      this.classData = {
        classNumber: response.schoolClass.classNumber,
        classAddition: response.schoolClass.classAddition,
        name: response.schoolClass.name,
        classCode: schoolClassCode,
        id: response.schoolClass.id,
        grade: response.schoolClass.grade ?? {id: '', name: ''},
        numberStudents: 0,
        createdAt: '',
        schoolClassYear: {
          id: -1,
          endYear: -1,
          startYear: -1
        },
        teachers: []
      };

      this.setClientId(response.clientId);

      this.updateLastSuccessClassCode(schoolClassCode);
    } else {
      this.deleteLastSuccessClassCode();
    }

    this._isLoggedIn.next(isSuccess);
    return isSuccess;
  }

  logOut() {
    this.deleteLastSuccessClassCode();
    this._isLoggedIn.next(false);
  }

  isLoggedIn(): boolean {
    return this._isLoggedIn.value;
  }

  onLoginStateChange(): Observable<boolean> {
    return this._isLoggedIn;
  }

  private updateLastSuccessClassCode(code: string): void {
    window.localStorage.setItem(this.LOCAL_STORAGE_KEY_LAST_CLASS_CODE_INPUT, code);
  }

  private getLastSuccessClassCode(): string|null {
    return window.localStorage.getItem(this.LOCAL_STORAGE_KEY_LAST_CLASS_CODE_INPUT);
  }

  private deleteLastSuccessClassCode(): void {
    window.localStorage.setItem(this.LOCAL_STORAGE_KEY_LAST_CLASS_CODE_INPUT, "");
  }

  onLogInStateChanged() {
    return this._isLoggedIn.asObservable();
  }

  getClientId(): string {
    return this._clientId;
  }

  setClientId(clientId: string): void {
    this._clientId = clientId;
  }

}
